import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetUserVerifiedPhoneNo($userId: ID!) {
    getUserPhoneNumber(userId: $userId) {
      userId
      countryCode
      e164PhoneNo
      intlPhoneNo
    }
  }
`

export const getUserPhoneNumberKey = getQueryNames(query)[0]

export default query
